import Restaurant from "@/domain/restaurant/Restaurant";
import User from "@/domain/user/User";

export default class AuthDto {
  user!: User;
  restaurants: Restaurant[] = [];

  constructor(jsonObj?: AuthDto) {
    if (jsonObj) {
      this.user = jsonObj.user;
      for (let i = 0; i < jsonObj.restaurants.length; i++) {
        this.restaurants.push(new Restaurant(jsonObj.restaurants[i]));
      }
    }
  }
}
